import React from 'react';
import Cookies from 'js-cookie';
import ManagementDashboardFilters from '../Management/ManagementDashboardFilters';
import SalesAccountabilityPanel from '../Management/SalesAccountabilityPanel';
import SalesProgressionView from '../Management/SalesProgressionView';

const VerticalProgressionLayout = ({ progression, accountability = null }) => (
  <div
    className={`flex flex-col items-stretch gap-5 ${accountability ? 'xl:flex-row' : ''}`}>
    <div className="min-w-0 flex-1">{progression}</div>
    {accountability ? <div className="w-full shrink-0 xl:w-[22rem]">{accountability}</div> : null}
  </div>
);

const SalesProgressionTab = ({
  filters,
  onFiltersChange,
  onFiltersLoadingChange = () => {}
}) => {
  const salesManagerId = Number(Cookies.get('userId'));
  const isSalesExecutive = Cookies.get('userDesignationLevel') === 'Low';

  const resolvedProjectId =
    filters?.projectID != null && String(filters.projectID) !== ''
      ? Number(filters.projectID)
      : null;

  const progressionView = (
    <SalesProgressionView
      key={resolvedProjectId}
      projectID={filters?.projectID}
      salesManagerId={salesManagerId}
    />
  );

  return (
    <div className="w-full pt-[7rem] pl-5 pr-5 pb-8">
      <div className="flex w-full flex-col gap-5">
        <div className="max-w-[280px]">
          <ManagementDashboardFilters
            onFiltersChange={onFiltersChange}
            onLoadingChange={onFiltersLoadingChange}
            initialProjectID={filters?.projectID}
            initialMonth={filters?.month}
          />
        </div>

        {isSalesExecutive ? (
          progressionView
        ) : (
          <VerticalProgressionLayout
            progression={progressionView}
            accountability={
              <SalesAccountabilityPanel
                key={resolvedProjectId}
                projectID={filters?.projectID}
                selectedSalesManagerId={salesManagerId}
              />
            }
          />
        )}
      </div>
    </div>
  );
};

export default SalesProgressionTab;
